// STUDIO-NOTICE-UI-CONSOLIDATION-1 · TEST 화면에서만 일반 완료·안내 알림 약 1초 후 종료 (오류·경고는 기존 유지).
import { useEffect } from 'react';
import { toast } from 'sonner';

export const SHORT_TOAST_MS = 1000;

export const useShortToast = (enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const orig = { success: toast.success, info: toast.info };
    toast.success = (m, o) => orig.success(m, { duration: SHORT_TOAST_MS, ...(o || {}) });
    toast.info = (m, o) => orig.info(m, { duration: SHORT_TOAST_MS, ...(o || {}) });
    return () => { toast.success = orig.success; toast.info = orig.info; };
  }, [enabled]);
};

// PC 보조 콘솔 섹션 숨김 체크박스 (localStorage 유지).
export const readHidePref = (key) => { try { return localStorage.getItem(`livemoa_console_hide_${key}`) === '1'; } catch { return false; } };
export const writeHidePref = (key, v) => { try { localStorage.setItem(`livemoa_console_hide_${key}`, v ? '1' : '0'); } catch { /* noop */ } };
